module.exports = __webpack_public_path__ + "static/media/s14.e4e7ac77.png";